import { createApi } from "./apiFactory";
import { Backend_LOCAL_PROXY, icfUtilsURL, icfUtilsURLToken, icfPlatformAgentsURLToken} from "../../constant";


export const api = createApi({
  baseURL: Backend_LOCAL_PROXY,  //process.env.NODE_ENV === "production" ? "https://api-aiwriter-services-poc.otsuka-us.com" : "",
  utilsURL: icfUtilsURL,
  utilsToken: icfUtilsURLToken,
  platformAgentsToken: icfPlatformAgentsURLToken,
});
